var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrencyPoundsSterling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "currency-pounds_sterling") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BDF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003FD1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-3",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7849991,39 L12,39 L12,34.1339988 C15.6089996,33.6270006 18.081001,30.9720009 18.1409975,27.5669978 C18.1409975,27.0809979 18.0389993,26.612998 17.9189958,26.189998 L12.0839982,26.189998 L12.0839982,21.8729968 L16.622996,21.8729968 C15.9149943,20.1509987 15.4259961,18.6509971 15.4259961,16.9469991 C15.4259961,11.9189979 19.5809974,9 26.7359965,9 C29.450998,9 31.5209977,9.20400172 33.425994,9.66899818 L33.425994,14.5949959 C31.478996,14.1299942 29.6969962,13.9259977 27.6089964,13.9259977 C23.8799986,13.9259977 21.5699971,15.5069992 21.5699971,18.0599955 C21.5699971,19.4369953 21.9359988,20.6549934 22.4219988,21.8699933 L30.8759961,21.8699933 L30.8759961,26.1869945 L23.6999986,26.1869945 C23.8230004,26.5919945 23.9040004,27.0389962 23.9040004,27.5039926 C24.0270021,29.9579941 22.7279988,32.2679903 20.558999,33.4019902 L20.558999,33.7859919 L34.7879974,33.7859919 L34.7879974,39 L34.7849991,39 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyPoundsSterling);
export default __webpack_public_path__ + "static/media/currency-pounds_sterling.4a0a645727e077fd632601705faac3ef.svg";
export { ForwardRef as ReactComponent };